/**
 * Normalize API org payload to an array so callers can always use [0].
 */
export const normalizeOrganizationList = (organizationData) => {
  if (!organizationData) return [];
  if (Array.isArray(organizationData)) return organizationData.filter(Boolean);
  if (organizationData.data) {
    return normalizeOrganizationList(organizationData.data);
  }
  return [organizationData];
};

const hasValue = (value) =>
  value !== undefined && value !== null && String(value).trim() !== "";

export const calculateKycStatus = (organizationData) => {
  const orgs = normalizeOrganizationList(organizationData);
  if (orgs.length === 0 || !orgs[0]) {
    return {
      completionPercentage: 0,
      completedSteps: 0,
      incompleteSteps: 3,
      totalSteps: 3,
      steps: {
        companyInfo: false,
        ownersInfo: false,
        businessInfo: false,
      },
      isApproved: false,
    };
  }

  const org = orgs[0];

  // Step 1 — company / organization basics
  const isStep1Complete = Boolean(
    hasValue(org.name) &&
      hasValue(org.type) &&
      hasValue(org.address) &&
      hasValue(org.email) &&
      hasValue(org.phone)
  );

  // Step 2 — owner info. Prefer ownerIdentificationType (step 2 field);
  // modeOfIdentification is also used by step 3 business ID.
  const ownerIdType =
    org.ownerIdentificationType || org.modeOfIdentification;
  const isStep2Complete = Boolean(
    (hasValue(org.ownerFullName) || hasValue(org.ownerID)) &&
      (hasValue(org.ownerEmail) || hasValue(org.email)) &&
      (hasValue(org.ownerPhone) || hasValue(org.phone)) &&
      hasValue(ownerIdType)
  );

  // Step 3 — business CAC + business identification docs (accept casing aliases).
  const cacNumber =
    org.CACRegistrationCertificateNumber ||
    org.cacRegistrationCertificateNumber;
  const cacImage =
    org.CACRegistrationCertificateImage ||
    org.cacRegistrationCertificateImage;
  const businessIdType =
    org.modeOfIdentification || org.businessModeOfIdentification;
  const businessIdImage =
    org.identificationImage || org.businessIdentificationImage;

  const isStep3Complete = Boolean(
    hasValue(cacNumber) &&
      hasValue(cacImage) &&
      hasValue(businessIdType) &&
      hasValue(businessIdImage)
  );

  const totalSteps = 3;
  const completedSteps =
    (isStep1Complete ? 1 : 0) +
    (isStep2Complete ? 1 : 0) +
    (isStep3Complete ? 1 : 0);
  const incompleteSteps = totalSteps - completedSteps;

  const completionPercentage = Math.round((completedSteps / totalSteps) * 100);

  return {
    completionPercentage,
    completedSteps,
    incompleteSteps,
    totalSteps,
    steps: {
      companyInfo: isStep1Complete,
      ownersInfo: isStep2Complete,
      businessInfo: isStep3Complete,
    },
    isApproved: org.status === "approved",
  };
};

export const calculateKycCompletionPercentage = (organizationData) => {
  return calculateKycStatus(organizationData).completionPercentage;
};
